module.exports = __webpack_public_path__ + "static/img/SC13.e1677ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/SC13.jpg
// module id = OgaC
// module chunks = 0